export class AppConst {
  // 外部URL
  static readonly url = {
    // 問い合わせ
    inquiry:
      'https://docs.google.com/forms/d/e/1FAIpQLSfDjNaMmUwd6_eSvS4rtrrYjTbJgYibVDKiIbazj5wHclEdHQ/viewform?usp=sf_link',
    // プライバシーポリシー
    privacy: 'https://branq.jp/privacypolicy/',
    // 利用規約
    term: 'https://branq.jp/term/',
    // アップグレード
    upgrade:
      'https://docs.google.com/forms/d/e/1FAIpQLSfDjNaMmUwd6_eSvS4rtrrYjTbJgYibVDKiIbazj5wHclEdHQ/viewform?usp=sf_link',
    // ヘルプサポート
    support:
      'https://docs.google.com/forms/d/e/1FAIpQLSfDjNaMmUwd6_eSvS4rtrrYjTbJgYibVDKiIbazj5wHclEdHQ/viewform?usp=sf_link',
  };

  // システムが画像として扱うファイルのMIMEタイプ
  static readonly imageTypes = ['image/jpeg', 'image/png', 'image/gif'];

  // システムが取り扱うステータスコード
  static readonly httpStatusCode = {
    paramInvalid: 400,
    accessDenied: 403,
    accessNotFound: 404,
    entryUnprocessable: 422,
    serverInternalError: 500,
  };

  // 利用規約のサンプル文
  static readonly termSample =
    '<p>ご利用いただく前に必ずご確認ください。</p><p>ご利用いただいた方は、本規約をすべて確認の上「同意」したとみなさせていただきます。</p><ul><li>当クイズコンテンツは、株式会社Branq（以下、当社）が提供しております。</li><li>当コンテンツは、事前に通知することなく、システムメンテナンスや不具合等により中止・中断・終了することがあります。</li></ul><p><strong>【禁止事項】</strong></p><p>当コンテンツは以下の行為を禁止しております。</p><ul><li>当コンテンツの提供を妨げる行為。</li><li>自動プログラムの利用。</li><li>特定の団体や個人に対する誹謗中傷。</li><li>公序良俗に反する行為。</li><li>宣伝及び勧誘行為。</li><li>その他、運営事務局が不適切だと判断した行為。</li></ul><p>【<strong>登録情報の取り扱いについて】</strong></p><p>クイズコンテンツで登録いただいた情報は以下の範囲で利用します。</p><ul><li>クイズ結果を利用者がシェアをする。</li><li>クイズ結果をご案内する。</li><li>利用者の属性などをリサーチデータとして利用する。</li><li>個人を特定しない形で当社、及び、当社を活用して本クイズを生成している事業会社のマーケティング活動に利用させて頂く場合があります。</li><li><a href="https://branq.jp/privacypolicy/" rel="noopener noreferrer" target="_blank" style="color: rgb(21, 120, 214);">当社のプライバシーポリシーはこちらからご確認お願いいたします</a>。</li></ul><p><strong>【その他の注意事項】</strong></p><ul><li>本コンテンツの利用に関して利用者に発生したいかなる損害についても、当社は一斉責任を負いません。</li><li>機種・OS・ブラウザ等の理由により一部のPC、スマートフォン、タブレット等では、ご利用いただけない場合もございます。</li><li>本コンテンツの内容は、予告なく変更する場合があります。また、本利用規約は、当社の判断により随時改訂することができるものとします。</li></ul>';
}
